export default ["icon-bed","icon-door","icon-interference","icon-moon","icon-obstacle","icon-radar","icon-refresh","icon-sun"]